import {
  Alert,
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import Subtitle from 'src/components/Subtitle';
import { DebentureLiabilitySeries } from 'src/types/operations/debentures';

import OperationDebenturesLiabilityQuoteRow from './OperationDebenturesLiabilityQuoteRow';

interface OperationDebenturesLiabilityQuotesProps {
  series: DebentureLiabilitySeries[];
  isLoading?: boolean;
}

export default function OperationDebenturesLiabilityQuotes({
  series,
  isLoading = false,
}: OperationDebenturesLiabilityQuotesProps) {
  if (isLoading) {
    return (
      <Box>
        <Skeleton
          variant="text"
          width={120}
          height={20}
          sx={{ mb: 1, mt: 3 }}
        />
        <Box sx={{ height: 2, backgroundColor: 'black', mb: 2 }} />
        <Skeleton variant="rectangular" width="100%" height={200} />
      </Box>
    );
  }

  if (!series.length) {
    return (
      <>
        <Subtitle title="Títulos" />
        <Alert severity="info">Nenhum dado de títulos disponível.</Alert>
      </>
    );
  }

  return (
    <>
      <Subtitle title="Títulos" />
      <TableContainer component={Paper} square sx={{ mb: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell width={36} />
              <TableCell
                sx={(theme) => ({
                  fontSize: '12px',
                  fontWeight: theme.typography.fontWeightBold,
                })}>
                Classe da Debênture
              </TableCell>
              <TableCell
                sx={(theme) => ({
                  fontSize: '12px',
                  fontWeight: theme.typography.fontWeightBold,
                })}>
                Série
              </TableCell>
              <TableCell
                align="right"
                sx={(theme) => ({
                  fontSize: '12px',
                  fontWeight: theme.typography.fontWeightBold,
                })}>
                Valor Emitido
              </TableCell>
              <TableCell
                align="right"
                sx={(theme) => ({
                  fontSize: '12px',
                  fontWeight: theme.typography.fontWeightBold,
                })}>
                Data de Referência
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {series.map((row) => (
              <OperationDebenturesLiabilityQuoteRow key={row.id} series={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
